export default "__VITE_ASSET__Cvn$rIMj__"